import {mapItems, flatten, filterItems, size} from 'ldash'
import {Actions} from 'uix/registries'
import log from 'uix/logging'
import {NTYPE} from './const'

export const DOMAIN_PINNED = ({
  domains,
  treeById,
  treePinned,
  buildVlType,
  buildStaticDomainNode,
}) => ({
  buildAfter: NTYPE.DOMAIN,
  //~ isEnabled: node => {
  //~ log.x(domains, node.dname)
  //~ return size(treePinned) > 0 && (log.x('XXX', node) || !domains.data[node.dname].isGhost)
  //~ },
  tabs: node => [['tree', 'list']],
  buildNodes: flatNodes => {
    // treePinned has layout {otid: is_pinned}
    let pinned_otids = mapItems(
      treePinned,
      (otid, isPinned) => otid,
      (otid, isPinned) => otid && isPinned
    )

    let unresolved = filterItems(
      treePinned,
      (otid, isPinned) => isPinned && otid && !treeById[otid]
    )
    let loaded = unresolved.length == 0
    if (pinned_otids.length == 0) {
      loaded = true
    }
    // due to missing subdomain logic we building only one for the root domain
    let containerNodes = flatNodes[NTYPE.DOMAIN]
      .map(dnode => {
        //~ let nodes = pinned_otids.map(otid => treeById[otid]).filter(e => e)
        //~ let domain_filtered = nodes.filter(
        //~ node => dnode.dname == domains.rootDomain || dnode.odid == node.odid
        //~ )
        if (size(pinned_otids) == 0) return null
        // maybe more subdomain logic, ... maybe not
        if (dnode.dname != domains.rootDomain) return null
        //~ if (domains.data[dnode.dname].isGhost) return null
        let extra = {pinned_otids}
        return buildStaticDomainNode(NTYPE.DOMAIN_PINNED, dnode, 'Pinned', loaded, extra)
      })
      .filter(e => e)

    let pinnedNodes = flatten(
      containerNodes.map(dnode =>
        dnode.extra.pinned_otids
          .filter(otid => treeById[otid])
          .map(otid => buildVlType({otid, idContext: dnode.id}))
      )
    )
    return [...containerNodes, ...pinnedNodes]
  },
  getChildren: node => Actions.getTreeNodes(node.extra.pinned_otids),
  storeMap: root => ({treePinned: root.data.tree.pinned}),
})
